import { SOURCE_NETWORKS_STEP, SOURCE_STORY_DELIVERY } from '../../../constants/network-connection-sources';
import { INSTAGRAM_ID } from '../../../constants/networks';

export default {
    computed: {
        connectionSource() {
            return this.$route.query.connectionSource
                ? JSON.parse(decodeURIComponent(this.$route.query.connectionSource))
                : this.defaultConnectionSource;
        },
        connectionSourceRequestData() {
            return this.buildConnectionSourceRequestData(this.connectionSource);
        },
        defaultConnectionSource() {
            return {
                name: SOURCE_NETWORKS_STEP
            };
        }
    },
    methods: {
        handleStartConnection(connectionSource) {
            this.$router.push({
                name: 'v2.campaign.proposal.networks.network',
                params: {
                    network: 'graph',
                    networkId: INSTAGRAM_ID
                },
                query: this.buildConnectionSourceRequestData(connectionSource)
            });
        },
        handleConnectInstagram() {
            this.$router.push({
                name: 'v2.campaign.proposal.networks.instagram.steps',
                query: this.connectionSourceRequestData
            });
        },
        handleCompleteConnection() {
            const handlingMap = {
                [SOURCE_NETWORKS_STEP]: () =>
                    this.$router.push({
                        name: 'v2.campaign.proposal.networks'
                    }),
                [SOURCE_STORY_DELIVERY]: (connectionSource) =>
                    this.$router.push({
                        name: 'v2.campaign.proposal.task.delivery.story',
                        params: connectionSource.data
                    })
            };

            return handlingMap[this.connectionSource.name](this.connectionSource);
        },
        handleFailedConnection(query) {
            this.$router.push({
                name: 'v2.campaign.proposal.networks.failed',
                params: { network: 'graph' },
                query: {
                    ...this.connectionSourceRequestData,
                    ...query
                }
            });
        },
        buildConnectionSourceRequestData(connectionSource) {
            return {
                connectionSource: encodeURIComponent(JSON.stringify(connectionSource))
            };
        }
    }
};
